import type { TextSize } from '@octopus-do/octopus-project-core'
import { TinyDropdownMenu, Toolbar } from '@octopus-do/octopus-storybook'
import type React from 'react'
import { forwardRef } from 'react'

import { TEXT_SIZE_MENU_ID, TEXT_SIZE_OPTIONS } from './constants'

const Content: React.FC = () => (
  <TinyDropdownMenu.Grid columns={1}>
    {TEXT_SIZE_OPTIONS.map(({ icon, id, tooltip }) => (
      <TinyDropdownMenu.IconOption
        icon={icon}
        id={id}
        key={id}
        tooltip={tooltip}
      />
    ))}
  </TinyDropdownMenu.Grid>
)

interface TriggerProps {
  disabled: boolean
  textSize: TextSize
}

const Trigger = forwardRef<HTMLButtonElement, TriggerProps>(
  ({ disabled, textSize }, ref) => {
    const { active, toggle } = TinyDropdownMenu.useTrigger()

    const current =
      TEXT_SIZE_OPTIONS.find(({ id }) => id === textSize) ??
      TEXT_SIZE_OPTIONS[0]

    return (
      <Toolbar.DropdownButton
        active={active}
        disabled={disabled}
        icon={current.icon}
        onClick={toggle}
        ref={ref}
        tooltip="Font size"
      />
    )
  }
)

interface Props {
  disabled?: boolean
  textSize: TextSize
}

export const TextSizeMenu: React.FC<Props> = ({
  disabled = false,
  textSize,
}) => {
  const { onClick } = Toolbar.useToolbarClick(TEXT_SIZE_MENU_ID)

  return (
    <TinyDropdownMenu.Root
      active={[textSize]}
      content={Content}
      onClick={onClick}
      width="fit"
    >
      <Trigger disabled={disabled} textSize={textSize} />
    </TinyDropdownMenu.Root>
  )
}
